module.exports = __webpack_public_path__ + "static/media/map_background.8088b065.png";